module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7fab4344ee6c8c4dbc448efba64cb49a.png";